export default (_condition, outputTrue, outputFalse, options) => {
  if (options === undefined) {
    options = outputFalse;
    outputFalse = '';
  }
  return _condition ? outputTrue : outputFalse;
};